import { render, staticRenderFns } from "./Circle.vue?vue&type=template&id=3463e328&scoped=true&"
var script = {}
import style0 from "./Circle.vue?vue&type=style&index=0&id=3463e328&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3463e328",
  null
  
)

export default component.exports